import { get, post } from "@Api";
import { IResponse } from "@Lib/request";
import * as ts from "@Types/buyCar";
import { IBrandSelectData, IKindSelectData, IModelSelectData } from "@Types/buyCar";
import { EBrandSelectType } from "@Types/constants";
import { path } from "./url";
const { newCarApiV3, newCarApiV2, newCarApiV4 } = path;

export async function fetchPaging(url) {
  return await get(url);
}

export async function fetchSuperTestShock(params?: any) {
  return await get(`${newCarApiV3}/superTest/shock`, params);
}

export async function fetchArticlePolymer(params?: any) {
  return await get(`${newCarApiV3}/article/polymer`, params);
}

export async function fetchCampaignsWinners(params?: any) {
  // return await get(`http://127.0.0.1:4523/mock/345128/api/v3/campaigns/inquiry-2021/winners`)
  return await get(`${newCarApiV3}/campaigns/inquiry-2021/winners`, params);
}

// 活動詳情
export async function fetchActiveInfo(params) {
  return await get(`${newCarApiV2}/active/info`, params);
}

export async function userInfo(params) {
  return await get(`${newCarApiV2}/u/userInfo`, params);
}

/** 获取车款 */
export async function fetchNewCarKinds(params?: {
  type?: EBrandSelectType;
  b: number;
}): Promise<IResponse<IKindSelectData>> {
  return await get(`${newCarApiV2}/kind/select`, {
    type: params?.type || EBrandSelectType.BASE,
    ...params,
  });
}

/** 获取厂牌 */
export async function fetchNewCarBrands(params?: {
  type?: EBrandSelectType;
  hasKind?: number;
}): Promise<IResponse<IBrandSelectData>> {
  return await get(`${newCarApiV2}/brand/select`, {
    type: params?.type || EBrandSelectType.BASE,
    ...params,
  });
}

/**
 *
 * @param params (车型类型,车型id)
 * @returns
 */
export async function fetchNewCarModel(params?: {
  type?: EBrandSelectType;
  k: number;
}): Promise<IResponse<IModelSelectData>> {
  return await get(`${newCarApiV2}/model/select`, {
    type: params?.type || EBrandSelectType.BASE,
    ...params,
  });
}

export async function fetchSaleLesAgentJobs() {
  return await get(`${newCarApiV3}/saleLeads/agent/jobs`);
}

export async function fetchSaleLesHotKinds() {
  return await get(`${newCarApiV3}/saleLeads/hotKinds`);
}

export async function fetchSaleLesBrandList(params) {
  return await get(`${newCarApiV3}/saleLeads/brandList`, params);
}

export async function fetchMovieBrandList() {
  return await get(`${newCarApiV3}/saleLeads/agent/movie/brandList`);
}

export async function fetchSaleLesBroadcast() {
  return await get(`${newCarApiV3}/saleLeads/broadcast`);
}

export async function fetchSaleLesStatistics() {
  return await get(`${newCarApiV3}/saleLeads/statistics`);
}

export async function fetchSaleLesHotInquiryNav() {
  return await get(`${newCarApiV3}/saleLeads/hotInquiry/nav`);
}

export async function fetchSaleLesHotInquiry(params: ts.paramsHotInquiry) {
  return await get(`${newCarApiV3}/saleLeads/hotInquiry`, params);
}

export async function fetchSaleLeaderboard(params: ts.paramsLeaderboard) {
  return await get(`${newCarApiV3}/saleLeads/leaderboard`, params);
}

export async function fetchSaleNewlyListedCar(params: ts.ParamsNewlyListedCar) {
  return await get(`${newCarApiV3}/newlyListedCar`, params);
}

export async function fetchSaleLeadsDealer(params: { b: number; limit?: number }) {
  return await get(`${newCarApiV3}/saleLeads/dealers`, params);
}

export async function fetchSaleLeadsDealerBrands() {
  return await get(`${newCarApiV3}/saleLeads/dealer/brands`);
}

export async function fetchAgentRecommendMovie(params?: { k: number; b: number }) {
  return await get(`${newCarApiV3}/saleLeads/agent/recommendMovie`, params);
}

// 热门询价导航
export async function inquiryNav() {
  return await get(`${newCarApiV3}/saleLeads/hotInquiry/nav`);
}
export async function fetchAgentSales(params: any) {
  return await get(`${newCarApiV3}/agent/sales/${params.id}`, params);
}

export async function fetchSaleLeadsHotInquiry(params: any) {
  return await get(`${newCarApiV3}/saleLeads/hotInquiry`, params);
}

export async function fetchSaleLeadsBrandList() {
  return await get(`${newCarApiV3}/saleLeads/brandList`);
}

export async function fetchSaleLeadsAgentMovies(params: any) {
  return await get(`${newCarApiV3}/saleLeads/agent/movies`, params);
}

export async function fetchSaleLeadsAgentDetail(params: any) {
  return await get(`${newCarApiV3}/saleLeads/agent/movies/${params.id}`);
}

export async function fetchLike(params) {
  return await get(`${newCarApiV3}/like`, params);
}

export async function fetchSaleLeadsAgentRecommentMovies(params?: any) {
  return await get(`${newCarApiV3}/saleLeads/agent/recommendMovies`, params);
}

export async function fetchSaleLeads(params?: { tagLimit?: number; k?: number | "" }) {
  return await get(`${newCarApiV3}/saleLeads/statistics`, params);
}

export async function fakeFavorite(params: {
  /**
   * add 关注， cancel 为取消
   */
  action: "add" | "cancel";
  /**
   * 对象id，影音id，用户id
   */
  objectId: number;
  /**
   * 对象类型，11为自建短影音   3 长影音    20 为关注用户
   */
  objectType: 11 | 3 | 20 | 10;
}): Promise<any> {
  return await post(`${newCarApiV4}/common/favorite`, params);
}

export async function fetchAgents(params: {
  limit: number;
  brandId?: number;
  sort?: "precise" | "score" | "distance" | "service" | "weight" | "movie";
  lat?: number;
  lng?: number;
  region?: number;
  excludeIds?: string;
}) {
  return await get(`${newCarApiV3}/agents`, params);
}

export async function fetchRace(params: any) {
  return await get(`${newCarApiV3}/race`, params);
}

export async function fetchNewlyListedCar(params: { y?: string; m?: string; type: string; limit: 6 }) {
  return await get(`${newCarApiV3}/newlyListedCar`, params);
}

export async function fetchPage(api: string) {
  return await get(api);
}
